import { useState } from "react";
import styles from '../apppay.module.css';
import { DollarSign, Edit } from "react-feather";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Checkbox, FormControlLabel } from "@mui/material";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import Autocomplete from "react-google-autocomplete";
import { forwardRef } from "react";
import { useEffect } from "react";

const MoneyField = forwardRef((props, ref) => {
    return <NumberFormat prefix="" displayType="input" type="text" thousandSeparator={true} allowNegative={false} decimalScale={2} fixedDecimalScale {...props} />;
});

const FiveDigitFieldformat = forwardRef((props, ref) => {
    return <NumberFormat prefix="" displayType="input" type="text" thousandSeparator={false} decimalScale={0} {...props} />;
});

const Step1 = ({ tenantDet, tenantDet2, setPaymentData, setIsSecondPaymentStep }) => {
    const [showBillingInfo, setShowBillingInfo] = useState(false);
    const [amountType, setAmountType] = useState('');

    const schema = yup.object().shape({
        amount_type: yup.mixed().required('This field is required'),
        amount: yup.string().required('This field is required'),
        description: yup.string().trim().required('This field is required').max(200, 'Description cannot be more than 200 characters').test('has-alphanumeric', 'Please enter a valid description', (value) => !!value && /[a-zA-Z0-9]/.test(value)),
        full_name: yup.string().required('This field is required').max(50, 'Full name cannot be more than 50 characters'),
        email: yup.string().required('This field is reuired').email('Invalid E-mail'),
        address: yup.string(),
        address2: yup.string().max(50, 'Address 2 cannot be more than 50 characters'),
        city: yup.string(),
        state: yup.string(),
        zip: yup.string(),
        term_cond: yup.boolean().required('This field is required').test('is-agree', 'This field is Required', (value, context) => value === true)
    });

    const { register, handleSubmit, control, errors, setValue, clearErrors } = useForm({
        resolver: yupResolver(schema), mode: 'onChange'
    });

    useEffect(() => {
        if (tenantDet) {
            setValue('address', tenantDet?.address);
            setValue('address2', tenantDet?.address2);
            setValue('city', tenantDet?.city);
            setValue('zip', tenantDet?.zip);
            setValue('state', tenantDet?.state);

            setValue('addressnew', tenantDet.address + ', ' + tenantDet.city + ', ' + tenantDet.state + ' ' + tenantDet.zip);

            if (tenantDet.balance2 <= 0) {
                setTimeout(() => {
                    setValue('amount_type', 'other_amount');
                }, 100);
            }
        }

        if (tenantDet2) {
            setValue('full_name', tenantDet2?.full_name);
            setValue('email', tenantDet2?.email);
        }

    }, [tenantDet, tenantDet2, setValue]);

    const onPlaceSelected = (place) => {
        let address = "";
        let city = "";
        let state = "";
        let postcode = "";

        for (let component of place.address_components) {
            let componentType = component.types[0];
            switch (componentType) {
                case "street_number": {
                    address = component.long_name;
                    break;
                }
                case "route": {
                    address += ' ' + component.short_name;
                    break;
                }
                case "postal_code": {
                    postcode = component.long_name;
                    break;
                }
                case "locality":
                    city = component.long_name;
                    break;
                case "sublocality_level_1":
                    city = component.long_name;
                    break;
                case "administrative_area_level_3":
                    city = component.long_name;
                    break;
                case "administrative_area_level_1": {
                    state = component.short_name;
                    break;
                }
                default:
                    break;
            }
        }

        setValue('address', address);
        setValue('city', city);
        setValue('state', state);
        setValue('zip', postcode);
    }

    const onSubmit = async (data) => {
        let amount = data.amount.replace(/,/g, '');
        amount = parseFloat(amount);

        setPaymentData({ total_amount: amount, description: data?.description, amount: amount, rentRollId: tenantDet?.last_rent_roll_id, tenantId: tenantDet?.id, tenantInfoId: tenantDet2?.id, cus_name: data?.full_name, cus_email: data.email, cus_phone: tenantDet2?.phone, cus_addr1: data?.address, cus_addr2: data?.address2, cus_city: data?.city, cus_state: data.state, cus_zip: data.zip });

        setIsSecondPaymentStep(true);
    }

    return (<form onSubmit={handleSubmit(onSubmit)}>
        {(tenantDet?.balance2 <= 0) && <input type="hidden" name="amount_type" ref={register} />}

        <div className={`${styles.PayNowSec}`}>
            <div className={`${styles.BillingInfoTSection}`}>
                <p className={`${styles.PayNowSecTitle}`}>Payment information</p>
            </div>

            {(tenantDet?.balance2 > 0) && <div className={`${styles.ToggleBUFull}`}>
                <label className={`${styles.FormLabel}`} >Payment amount*</label>
                <div className={`${styles.CusRadioRow}`}>
                    <label className={`${styles.CusRadio}`}>
                        <input type="radio" name="amount_type" ref={register} control={control} value="total_due" onChange={e => { setAmountType('total_due'); setValue("amount", tenantDet.balance2); clearErrors(['amount_type', 'amount']); }} />
                        <div className={`${styles.checkmark}`}>Full balance</div>
                    </label>
                    <label className={`${styles.CusRadio}`}>
                        <input type="radio" name="amount_type" ref={register} control={control} value="other_amount" onChange={e => { setAmountType('other_amount'); setValue("amount", ''); clearErrors(['amount_type', 'amount']); }} />
                        <div className={`${styles.checkmark}`}>Other amount</div>
                    </label>
                    {errors.amount_type && <p className={`${styles.ErrorM2}`}>{errors.amount_type.message}</p>}
                </div>
            </div>}

            <div className={`${styles.FormGroupHalf} ${styles.Dollar}`}>
                <label className={`${styles.FormLabel}`} >Amount*</label>
                <div className={`${styles.Width100}`}>
                    <p className={`${styles.AccoDollarSign}`}><DollarSign /></p>
                    <Controller
                        name="amount"
                        render={({ onChange, value }) => (<MoneyField className={`${styles.formControl}`} value={value} onChange={(value) => { onChange(value); }} placeholder="0.00" readOnly={amountType === "total_due"} />)}
                        control={control}
                        ref={register}
                        className={`${styles.formControl}`}
                    />
                    {errors.amount && <p className={`${styles.ErrorM2}`}>{errors.amount.message}</p>}
                </div>
            </div>

            <div className={`${styles.FormGroupHalf}`}>
                <label className={`${styles.FormLabel}`} >Memo*</label>
                <div className={`${styles.Width100}`}>
                    <input className={`${styles.formControl}`} type="text" name="description" ref={register} />
                    {errors.description && <p className={`${styles.ErrorM2}`}>{errors.description.message}</p>}
                </div>
            </div>

        </div>

        <div className={`${styles.PayNowSec}`}>
            <div className={`${styles.BillingInfoTSection}`}>
                <p className={`${styles.PayNowSecTitle}`}>Billing Contact & address</p>
                {!showBillingInfo && <button className={`${styles.EditBillingBU}`} onClick={() => { setShowBillingInfo(!showBillingInfo); }}><Edit /></button>}
            </div>

            {!showBillingInfo && <div className={`${styles.BillingInfoTextSec}`}>
                <p className={`${styles.BillingTextList}`}>{tenantDet2?.full_name}</p>
                <p className={`${styles.BillingTextList}`}>{tenantDet2?.email}</p>
                <p className={`${styles.BillingTextList}`}>{tenantDet?.address}, {tenantDet?.address2}<br />{tenantDet?.city}, {tenantDet?.state} {tenantDet?.zip}</p>
            </div>}

            <div className={!showBillingInfo ? `${styles.BillingInfoFormSec} ${styles.BillingInfoFormSecHide}` : `${styles.BillingInfoFormSec}`}>
                <div className={`${styles.FormGroupHalf}`}>
                    <label className={`${styles.FormLabel}`} >Full name*</label>
                    <div className={`${styles.Width100}`}>
                        <input className={`${styles.formControl}`} placeholder="Full Name" type="text" name="full_name" ref={register} />
                        {errors.full_name && <p className={`${styles.ErrorM}`}>{errors.full_name.message}</p>}
                    </div>
                </div>
                <div className={`${styles.FormGroupHalf}`}>
                    <label className={`${styles.FormLabel}`} >Email*</label>
                    <div className={`${styles.Width100}`}>
                        <input className={`${styles.formControl}`} placeholder="example@gmail.com" type="email" name="email" ref={register} />
                        {errors.email && <p className={`${styles.ErrorM}`}>{errors.email.message}</p>}
                    </div>
                </div>

                <div className={`${styles.FormGroupFull}`}>
                    <label className={`${styles.FormLabel}`} >Address*</label>
                    <div className={`${styles.Width100}`}>
                        <Controller
                            className={`${styles.formControl}`}
                            render={(field) => (<Autocomplete
                                name="addressnew"
                                ref={register}
                                className={`${styles.formControl}`}
                                apiKey={process.env.REACT_APP_MAP_API_KEY}
                                options={{
                                    types: ["address"],
                                    componentRestrictions: { country: "us" },
                                    fields: ["address_components", "geometry"],
                                }}
                                onPlaceSelected={onPlaceSelected}
                                defaultValue={field?.value ? field?.value : ''}
                                onChange={(e) => field.onChange(e)} />)}
                            name="addressnew"
                            control={control}
                            autoComplete="off"
                            type="text"
                        />
                        <input className={`${styles.formControl}`} placeholder="Address" type="hidden" name="address" ref={register} />
                        {errors.address && <p className={`${styles.ErrorM}`}>{errors.address.message}</p>}
                    </div>
                </div>

                <div className={`${styles.FormGroupFull}`}>
                    <label className={`${styles.FormLabel}`} >Address line 2</label>
                    <div className={`${styles.Width100}`}>
                        <input className={`${styles.formControl}`} placeholder="Address line 2" type="text" name="address2" ref={register} />
                    </div>
                </div>

                <div className={`${styles.FormGroupHalf} ${styles.FormGroupHalfHide}`}>
                    <label className={`${styles.FormLabel}`} >City*</label>
                    <div className={`${styles.Width100}`}>
                        <input className={`${styles.formControl}`} placeholder="City" type="text" name="city" ref={register} />
                        {errors.city && <p className={`${styles.ErrorM}`}>{errors.city.message}</p>}
                    </div>
                </div>
                <div className={`${styles.FormGroupHalf} ${styles.FormGroupHalfHide} CusSelect`}>
                    <label className={`${styles.FormLabel}`} >State</label>
                    <div className={`${styles.Width100}`}>
                        <input className={`${styles.formControl}`} placeholder="State" type="text" name="state" ref={register} />
                        {errors.state && <p className={`${styles.ErrorM}`}>{errors.state.message}</p>}
                    </div>
                </div>

                <div className={`${styles.FormGroupHalf} ${styles.FormGroupHalfHide}`}>
                    <label className={`${styles.FormLabel}`} >Zip code*</label>
                    <div className={`${styles.Width100}`}>
                        <Controller className={`${styles.formControl}`} as={<FiveDigitFieldformat format="#####" />} placeholder="Zip code" control={control} name="zip" ref={register} />
                        {errors.zip && <p className={`${styles.ErrorM}`}>{errors.zip.message}</p>}
                    </div>
                </div>
            </div>

            <div className={`${styles.FormGroupFull}`}>
                <label className={`${styles.FormLabel}`} >Terms and Conditions</label>
                <div className={`${styles.TermsTextSec}`}>
                    <p>I authorize the debit of my checking/ savings account for the amount indicated above. I understand that because this is an electronic transaction, these funds may be withdrawn from my account immediately. If payment is rejected for Non-Sufficient Funds (NSF), I understand that another attempt to process the charge will be made in 30 days, and I agree to an additional $25 charge for each attempt returned NSF, which will be initiated as a separate transaction from the authorized payment.</p>
                    <FormControlLabel
                        label={"I agree to the terms and conditions"}
                        control={
                            <Controller
                                ref={register}
                                name="term_cond"
                                control={control}
                                render={(field) => <Checkbox {...field} onChange={(e) => field.onChange(e.target.checked)} />}
                            />
                        }
                    />
                </div>
                {errors.term_cond && <span className={`${styles.TermErrorMM}`}>{errors?.term_cond?.message}</span>}
            </div>
        </div>

        <button type="submit" className={`${styles.RentallAppliSubmitBU}`}>Continue</button>
    </form>);
}

export default Step1;